import { render, staticRenderFns } from "./Realizacja.vue?vue&type=template&id=6b7f0c42&scoped=true&"
import script from "./Realizacja.vue?vue&type=script&lang=js&"
export * from "./Realizacja.vue?vue&type=script&lang=js&"
import style0 from "./Realizacja.vue?vue&type=style&index=0&id=6b7f0c42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f0c42",
  null
  
)

export default component.exports